import { useEffect } from 'react';
import {
  getSubComponent,
  getSubComponentStyles,
} from '../../../utils/react.utils';
import FooterNavigation from '../../navigation/tabs/footer.navigation';

interface Props {
  children: any;
  title?: string;
  className?: string;
}

interface MLProps extends Props {
  layout?: 'alt' | 'default';
}

export const styles = {
  container: 'flex mobile:flex-col tablet-lg:flex-row h-full',
  header: 'mobile:hidden tablet-lg:flex flex-col ',
  'header-wrapper': 'tablet-lg:w-[100px] desktop:w-[400px]',
  'header-container':
    'fixed top-0 desktop:left-[150px] border-r border-dark-gray',
  'header-content':
    'w-[100px] desktop:w-[250px] ml-auto tablet-lg:flex flex-col desktop:block items-center relative h-screen',
  main: 'min-h-[calc(100vh-60px)] w-full flex justify-start',
  'main-wrapper': '',
  'navigation-wrapper': 'flex flex-row w-full justify-start h-full',
  navigation:
    'w-full border-b border-l border-dark-gray py-3 px-2 sticky top-0 bg-black z-20',
  default: {
    'main-content':
      'mobile:w-full laptop:w-[600px] desktop:w-[600px] flex-shrink-0',
    aside:
      'min-w-[350px] border-l border-dark-gray mobile:hidden laptop:block laptop:w-[calc(100vw-700px)] desktop:w-[calc(100vw-1001px)] pt-2 flex-shrink-0 basis-auto flex-grow h-[1100px] sticky top-0 bg-[#171718]',
  },
  alt: {
    'main-content':
      'mobile:w-full tablet-lg:w-[calc(100vw-100px)] desktop:w-[calc(100vw-400px)] flex-shrink-0',
    aside: 'hidden',
  },
};

type SubComponentNames =
  | 'Header'
  | 'Main'
  | 'Aside'
  | 'Navigation'
  | 'Content'
  | 'Banner';

function MainLayout(props: MLProps) {
  const { children, layout } = props;

  const Header = getSubComponent<SubComponentNames>(children, 'Header');
  const Aside = getSubComponent<SubComponentNames>(children, 'Aside');
  const Content = getSubComponent<SubComponentNames>(children, 'Content');

  const contentChildren = Content ? Content[0].props.children : {};

  const Navigation = getSubComponent<SubComponentNames>(
    contentChildren,
    'Navigation'
  );
  const Main = getSubComponent<SubComponentNames>(contentChildren, 'Main');
  const Banner = getSubComponent<SubComponentNames>(contentChildren, 'Banner');

  const navigationClassName = getSubComponentStyles(Navigation);
  const mainClassName = getSubComponentStyles(Main);
  const asideClassName = getSubComponentStyles(Aside);
  // const bannerClassName = getSubComponentStyles(Content);

  useEffect(() => {
    document.title = `The Base | ${props.title || ''}`;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles['header-wrapper']}>
          <div className={styles['header-container']}>
            <div className={styles['header-content']}>{Header}</div>
          </div>
        </div>
      </header>

      <main className={styles['main']}>
        <div className={styles['navigation-wrapper']}>
          <div className={styles[layout || 'default']['main-content']}>
            <nav className={styles.navigation}>
              <div className={navigationClassName || 'sticky top-0'}>
                {Navigation}
              </div>
            </nav>
            <div className={styles['main-wrapper']}>
              <header className={''}>{Banner}</header>
              <div className={mainClassName}>{Main}</div>
            </div>
          </div>
          <aside className={styles[layout || 'default'].aside}>
            <div className={asideClassName}>{Aside}</div>
          </aside>
        </div>
      </main>

      <FooterNavigation />
    </div>
  );
}

const Header = (props: Props) => props.children;
const Main = (props: Props) => props.children;
const Aside = (props: Props) => props.children;
const Navigation = (props: Props) => props.children;
const Content = (props: Props) => props.children;
const Banner = (props: Props) => props.children;

Header.displayName = 'Header';
Aside.displayName = 'Aside';
Navigation.displayName = 'Navigation';
Main.displayName = 'Main';
Content.displayName = 'Content';
Banner.displayName = 'Banner';

MainLayout.Header = Header;
MainLayout.Aside = Aside;
MainLayout.Navigation = Navigation;
MainLayout.Main = Main;
MainLayout.Content = Content;
MainLayout.Banner = Banner;

export default MainLayout;
